import { Link, useParams } from 'react-router-dom'
import { Button, Space, Tooltip } from 'antd'
import { DeleteOutlined, ReloadOutlined, EyeOutlined } from '@ant-design/icons'
import { ComplianceJobStatus, type ComplianceJobListItem } from '@/features/compliance/types'

type JobActionsCellProps = {
  row: ComplianceJobListItem
  onDelete: (id: string) => void
  orgPlatformId?: string
}

export function JobActionsCell({ row, onDelete, orgPlatformId: orgPlatformIdProp }: JobActionsCellProps) {
  const { id: orgIdFromRoute } = useParams<{ id: string }>()
  const orgId = orgPlatformIdProp ?? orgIdFromRoute
  const isProcessing =
    row.status === ComplianceJobStatus.Pending ||
    row.status === ComplianceJobStatus.Processing ||
    row.status === ComplianceJobStatus.Reviewing

  return (
    <Space size="small">
      {orgId && (
        <Tooltip title="Open job">
          <Link to={`/annual-compliance/org/${orgId}/job/${row.id}`}>
            <Button type="text" size="small" icon={<EyeOutlined />} />
          </Link>
        </Tooltip>
      )}
      {isProcessing ? (
        <span className="inline-flex items-center gap-1 text-gray-500">
          <ReloadOutlined spin />
          Reviewing…
        </span>
      ) : null}
      <Tooltip title="Delete job">
        <Button
          type="text"
          danger
          size="small"
          icon={<DeleteOutlined />}
          onClick={() => onDelete(row.id)}
        />
      </Tooltip>
    </Space>
  )
}
